import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { getDriverJobSeekerAdmin } from "../../features/admin3/admin3Slice";
import Btn from "../shared/button/Btn";
import InputSelectCity from "../shared/input/new/InputSelectCity";
import AdminIsArayanSurucuContainer from "../adminContainers/adminIlanlar/AdminIsArayanSurucuContainer";
import Pagination from "../shared/Pagination";
import InputSelect from "../shared/input/new/InputSelect";

const Container = styled.div`
  width: 100%;
  margin-block: 10px;
  background-color: ${({ theme }) => theme.secondaryBgColor};
  .container {
    width: 100%;

    .titles {
      width: 100%;
      margin-top: 30px;
      display: grid;
      grid-template-columns: repeat(13, 1fr); 
      padding-inline: 10px;
      gap: 15px;
      font-size: var(--font-size-sm);
      font-weight: var(--font-weight-lg);
      text-align: center;
      color: ${({ theme }) => theme.mainTextColor};
    }
  }
`;

const titles = ["İlan Tarihi", "Adı Soyadı", "Telefonu", "Ehliyet", "SRC", "İl/İller", "Maaş", "Ağır Vasıta Tecrübesi(yıl)", "Açıklama", "İlan Bitiş", "Onay","Durum","İş Buldu Mu?"]

const durumData = [
  {
    id:1,
    text:"Yayında",
    bool: true
  },
  {
    id:2,
    text:"Arşivde",
    bool: false
  }
]

const onayData = [
  {
    id: 0,
    text: "Onay Bekliyor",
    bool: true
  },
  {
    id: 1,
    text: "Onaylandı",
    bool: true
  },
  {
    id: 2,
    text: "Reddedildi",
    bool: true
  }
]

const IsArayanSuruculerAdmin = () => {
  const { theme } = useSelector((state) => state.layout);
  const { adminDriverJobSeekerList, adminDriverJobSeekerCount } = useSelector((state) => state.admin3);
  const dispatch = useDispatch()
  const [workCity, setWorkCity] = useState("")
  const [ilanDurumu, setIlanDurumu] = useState(null)
  const [onayDurum, setOnayDurum] = useState(null)

  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 10;

  const totalPages = Math.ceil(adminDriverJobSeekerCount / itemsPerPage);

  useEffect(() => {
    dispatch(getDriverJobSeekerAdmin({workCity: workCity, page: currentPage, isApproved: onayDurum?.id, isActive: ilanDurumu?.bool,}))
  }, [workCity, currentPage, onayDurum, ilanDurumu])

  const handleClear = () => {
    setWorkCity("")
    setOnayDurum(null)
    setIlanDurumu(null)
  }
  
  return (
    <Container theme={theme}>
      <div className="container">
        <div className="top-container">
          <InputSelectCity data={workCity?.value} setData={setWorkCity} name={"workCity"} labelText={"Çalışılacak İl"} />
          <InputSelect data={ilanDurumu?.text} setData={setIlanDurumu} initialOptions={durumData} name={"ilanDurumu"} labelText={"İlan Durumu"} />
          <InputSelect data={onayDurum?.text} setData={setOnayDurum} initialOptions={onayData} name={"onayDurum"} labelText={"Onay Durumu"} />
          <Btn color='#E85446' bgColor='transparent' padding='0 10px' handleClick={handleClear} >Temizle</Btn>
        </div>
        
        <div className="titles">
          {titles.map((item) => (
              <p>{item}</p>
          ))}
        </div>

        {adminDriverJobSeekerList?.map((item) => {
          return <AdminIsArayanSurucuContainer data={item} />
        })}
        {(adminDriverJobSeekerList && adminDriverJobSeekerList?.length > 0) && (
          <Pagination
            totalPages={totalPages}
            handleClick={setCurrentPage}
            currentPage={currentPage}
          />
        )}
      </div>
    </Container>
  );
};

export default IsArayanSuruculerAdmin;
